import { computed, ref, unref } from '@nuxtjs/composition-api'
import { Context } from '@nuxt/types'
import { MaybeRef } from '@vueuse/core'

import { parseSearchMode } from '@/modules/route-query'

const modes = ['list', 'map'] as const

export type SearchMode = typeof modes[number]

export default function () {
  /** 搜尋模式 */
  const mode = ref<SearchMode>(modes[0])
  const modeQueryObject = computed(() =>
    ({ mode: (mode.value !== modes[0]) ? mode.value : undefined })
  )
  const setModeFromQuery = (query: MaybeRef<Context['query']>) => {
    mode.value = parseSearchMode(unref(query), modes)
  }

  return {
    modes,
    mode,
    modeQueryObject,
    setModeFromQuery,
  }
}
